export const getallinterview = `
query GetAllInterviews(
  $page: Int
  $pageSize: Int
){
  getAllInterviews (
    page: $page
    pageSize: $pageSize
  ) {
    success
    error
    message
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
    screening {
      id
      candidateName
      onboardDate
      candidateNumber
      shortlistedDate
      interviewDate
      position{
        id
        positionName
      }
      client{
        id
        clientName
 
      }
      status
      shortlistFeedback
      interviewFeedback
      onboardedFeedback
      date
      createdBy
      createdAt
      updatedAt
      updatedBy
    }
  }
}
`

export const getallFilterinterview = `
query GetAllInterviews(
  $hrUserId: ID
  $page: Int
  $pageSize: Int
) {
  getAllInterviews(
    hrUserId: $hrUserId
    page: $page
    pageSize: $pageSize
  ) {
    success
    error
    message
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
    screening {
      id
      candidateName
      candidateNumber
      onboardDate
      shortlistedDate
      interviewDate
      position{
        id
        positionName
      }
      client{
        id
        clientName
      }
      status
      shortlistFeedback
      interviewFeedback
      onboardedFeedback
      srDate
      date
      createdBy
      createdAt
      updatedAt
      updatedBy
      onboardDate
    }
  }
}
`

export const searchInterview = `query SearchInterviewCandidates(
  $search: String!,
  $page: Int!,
  $pageSize: Int!
  $hrUserId: ID
) {
  searchInterviewCandidates(
    search: $search,
    page: $page,
    pageSize: $pageSize,
    hrUserId: $hrUserId
  ) {
    success
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
 
    screening {
      id
      candidateName
      onboardDate
      candidateNumber
      shortlistedDate
      interviewDate
 
      position {
        id
        positionName
      }
 
      client {
        id
        clientName
      }
 
      status
      shortlistFeedback
      interviewFeedback
      onboardedFeedback
      date
      createdBy
      createdAt
      updatedAt
      updatedBy
    }
  }
}`